import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import PropTypes from 'prop-types';
import Form from 'components/react-validation/components/form';
import Submit from 'components/react-validation/components/submit';
import * as Vali from 'helper/validator-helper';
import Textarea from '../../components/react-validation/components/text-area';
import Pagination from '../../components/pagination';
import { AppSettings } from '../../constants';
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';

class WorkOrderComments extends React.Component {
  static propTypes = {
    comments: PropTypes.any,
    privateNotes: PropTypes.any,
    WorkOrderProfile: PropTypes.any,
    addComment: PropTypes.func,
    fetchWorkOrderComments: PropTypes.func,
    fetchWorkOrderPrivateNotes: PropTypes.func,
    onClickDeletePrivateNotes: PropTypes.func,
    userProfile: PropTypes.any,
    hidePrivateNotes: PropTypes.bool
  };

  static defaultProps = {
    comments: []
  };

  static contextTypes = {
    currentPage: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      currentPrivateNotesPage: 1
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.comments.totalPage && this.state.loadingAddComment) {
      this.setState(
        {
          currentPage: nextProps.comments.totalPage,
          loadingAddComment: false
        },
        () => {
          this.props.fetchWorkOrderComments({
            size: 10,
            page: this.state.currentPage
          });
        }
      );
    }
    if (nextProps.privateNotes && this.state.loadingAddComment) {
      this.setState(
        {
          currentPrivateNotesPage: nextProps.privateNotes.totalPage,
          loadingAddComment: false
        },
        () => {
          this.props.fetchWorkOrderPrivateNotes({
            size: 10,
            page: this.state.currentPrivateNotesPage
          });
        }
      );
    }
  }

  onClickAddComment = e => {
    e.preventDefault();

    this.setState({ loadingAddComment: true });

    const params = this.commentForm.getValues();

    this.props.addComment(params.description);
    this.commentForm.resetForm(this.refs);
  };

  onClickAddNote = e => {
    e.preventDefault();

    this.setState({ loadingAddComment: true });

    const params = this.noteForm.getValues();
    this.props.addComment(params.description_note, '', true);
    this.noteForm.resetForm(this.refs);
  };

  onChangePage = param => {
    this.setState({
      currentPage: param.page
    });
    this.props.fetchWorkOrderComments(param);
  };

  onChangePrivateNotesPage = param => {
    this.setState({currentPrivateNotesPage: param.page });
    this.props.fetchWorkOrderPrivateNotes(param);
  };

  renderCommentList(comments) {
    if (_.isEmpty(comments)) {
      return <div className='col-sm-12 comment-list' />;
    }
    return (
      <div className='col-sm-12 comment-list'>
        {_.map(comments, (cmt, index) => {
          return (
          !cmt.isPrivateNote?
          <div className='comment-item' key={index}>
              <div className='comment-avatar'>
                <img
                  className='comment-avatar'
                  src='https://i.imgur.com/jNNT4LE.png'
                  height='40'
                  width='40'
                />
              </div>
              <div className='comment-content'>
                <div className='owner-info'>
                  <div className='owner-name'>{cmt.displayName} </div>
                  <div className='comment-time'>
                    {' '}
                    {moment(cmt.createdDate).format('MM/DD/YYYY')} at{' '}
                    {moment(cmt.createdDate).format('hh:mm A')}
                  </div>
                </div>
                <div className='text-pre-wrap'>{cmt.comment}</div>
              </div>
            </div>
            :null
          );
        })}
        <Pagination
          isDisableSelectSizePerPage={true}
          onChange={this.onChangePage}
          totalRecord={this.props.comments.totalRecord}
          totalPage={this.props.comments.totalPage}
          currentPage={this.state.currentPage}
        />
      </div>
    );
  }

  renderPrivateNotesList(privateNotes) {
    if (!privateNotes) {return null;}

    var comments = privateNotes.items;

    if (_.isEmpty(comments)) {
      return <div className='col-sm-12 comment-list' />;
    }
    return (
      <div className='col-sm-12 comment-list'>
        {_.map(comments, (cmt, index) => {
          return (
            cmt.isPrivateNote ?
            <div className='comment-item' key={index}>
              <div className='comment-avatar'>
                <img
                  className='comment-avatar'
                  src='https://i.imgur.com/jNNT4LE.png'
                  height='40'
                  width='40'
                />
              </div>
              <div className='comment-content'>
                <div className='owner-info'>
                  <div className='owner-name'>{cmt.displayName} </div>
                  <div className='comment-time'>
                    {' '}
                    {moment(cmt.createdDate).format('MM/DD/YYYY')} at{' '}
                    {moment(cmt.createdDate).format('hh:mm A')}
                    {
                      (this.props.userProfile && this.props.userProfile.userId === cmt.userId) &&
                      <i className='fa fa-trash' style={{cursor: 'pointer', marginLeft: 15}} onClick={() => this.props.onClickDeletePrivateNotes(cmt.id, this.state.currentPrivateNotesPage)}/>
                    }
                  </div>
                </div>
                <div className='text-pre-wrap'>{cmt.comment}</div>
              </div>
            </div>
            : null
          );
        })}
        <Pagination
          isDisableSelectSizePerPage={true}
          onChange={this.onChangePrivateNotesPage}
          totalRecord={this.props.privateNotes.totalRecord}
          totalPage={this.props.privateNotes.totalPage}
          currentPage={this.state.currentPrivateNotesPage}
        />
      </div>
    );
  }

  renderCommentSection() {
    // Builder, Homeowner can create and view comments
    // Subcontractor can only view comments when viewOnly is true otherwise he can create and view comments
    // Apply for RFS as well as punch list
    if (AppSettings.clientTypeValue !== 'Subcontractor' || (AppSettings.clientTypeValue === 'Subcontractor' && this.props.WorkOrderProfile.viewOnly === false))
    {
      return (
        <React.Fragment>
          <Form ref={ref => { this.commentForm = ref; }}>
            <div className='row comment'>
              <div className='col-sm-12'>
                <div style={{ marginBottom: 10 }}>
                  <Textarea
                    name='description'
                    ref='description'
                    className='form-control'
                    maxLength='1000'
                    rows='5'
                    validations={[Vali.required]}
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12'>
                <Submit className='btn btn-primary btn-submit btn-siteone' onClick={this.onClickAddComment}>Add</Submit>
              </div>
            </div>
          </Form>
          {<div className='row'>{this.renderCommentList(this.props.comments.items)}</div>}
        </React.Fragment>);
    }

    return (<div className='row'>{this.renderCommentList(this.props.comments.items)}</div>);
  }

  renderPrivateNoteSection() {
    // Builder can create and view private notes
    // Subcontractor can only view private notes when viewOnly is true otherwise he can create and view private notes
    // Homeowner can not view also create private notes
    if (!this.props.hidePrivateNotes && (AppSettings.clientTypeValue === 'Builder' || (AppSettings.clientTypeValue === 'Subcontractor' && this.props.WorkOrderProfile.viewOnly === false))) {
      return (
        <React.Fragment>
          <Form ref={ref => { this.noteForm = ref; }}>
            <div className='row comment'>
              <div className='col-sm-12'>
                <div style={{ marginBottom: 10 }}>
                  <Textarea
                    name='description_note'
                    ref='description_note'
                    className='form-control'
                    maxLength='1000'
                    rows='5'
                    placeholder="Add a note, this note won't be visible to the homeowners."
                    validations={[Vali.required]}
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12'>
                <Submit className='btn btn-primary btn-submit btn-siteone' onClick={this.onClickAddNote}>Add</Submit>
              </div>
            </div>
          </Form>

          <div className='row'>
            {this.renderPrivateNotesList(this.props.privateNotes)}
          </div>
        </React.Fragment>);
    }

    // Homeowner or Subcontractor with viewOnly equal to true get here
    return (AppSettings.clientTypeValue !== 'Homeowner' && !this.props.hidePrivateNotes ? <div className='row'>{this.renderPrivateNotesList(this.props.privateNotes)}</div> : null);
  }

  render() {
    return (
      <div className='wo-comments-wrapper col-xs-12 col-lg-8 col-sm-12 box-form-siteone'>
        <Tab.Container id='notes-tab' defaultActiveKey='comment'>
          <div>
            <Col sm={12} style={{ padding: 0 }}>
              <Nav className='wo-tab' bsStyle='tabs' onSelect={this.onSelectTab}>
                <NavItem eventKey='comment'>Comments</NavItem>
                {
                  AppSettings.clientTypeValue !== 'Homeowner' && !this.props.hidePrivateNotes &&
                  <NavItem eventKey='private-note'>Private notes</NavItem>
                }
              </Nav>
            </Col>
            <Col sm={12} style={{ padding: 0 }}>
              <Tab.Content animation>
                <Tab.Pane eventKey='comment' >
                  {this.renderCommentSection()}
                </Tab.Pane>
                <Tab.Pane eventKey='private-note'>
                  {this.renderPrivateNoteSection()}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Tab.Container>
      </div>
    );
  }
}

export default WorkOrderComments;



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/WorkOrderComments.js